/* eslint-disable react/forbid-prop-types,import/prefer-default-export,react/no-danger,import/no-unresolved,jsx-a11y/anchor-is-valid */
import React, { useContext, useMemo, useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, Switch, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MAIN_ICON_COLORS } from 'assets/components';
import { useSetting } from '../../../../utilities/sharedHooks/settings';
import { DashboardTabSkeleton } from '../../../../components/Placeholders';
import Icon from '../../../../components/Icon';
import SimpleTooltip from '../../../../components/SimpleTooltip';
import ModalLayout from '../../../../screens/shared/ModalLayout';
import Services from '../../../../routers/DashboardRouter/modals/Services';
import { MODAL_SCREENS } from '../../../../routers/DashboardRouter/constants';
import { ICONS } from '../../../../components/Icon/constants';
import { StatusBanner } from '../../shared';
import { GlobalContext } from '../../../../contexts/global/context';

export const DashboardLayout = ({ children }) => {
  const { pathname } = useLocation();
  const { t: translate } = useTranslation();
  const routesFound = children.filter((c) => c !== false);
  const routes = routesFound.map((c) => ({
    className: c.props.className || '',
    path: c.props.path,
    title: c.props.title,
    isRight: c.props.right,
    isDisabled: c.props?.disabled ?? c.props?.status?.disabled,
    isLoading: c.props?.status?.loading,
    icon: c.props.icon,
    image: c.props.image,
    activeIcon: c.props.activeIcon,
    isLink: c.props.isLink,
    isExternal: c.props.isExternal,
    modal: c.props.modal,
    services: c.props.services,
    tooltipLabel: c.props.tooltipLabel,
    tooltipTop: c.props.tooltipTop,
    tooltipLeft: c.props.tooltipLeft,
  }));

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentScreen, setCurrentScreen] = useState('');

  const { state, changeShowingStatusBanner } = useContext(GlobalContext);

  const [hoverIconsStatus, setHoverIconsStatus] = useReducer(
    (prev, next) => ({ ...prev, ...next }),
    {
      user_profile: false,
      question_mark: false,
    }
  );

  const showScreen = (screen) => {
    setCurrentScreen(screen);
    setIsModalVisible(true);
  };

  const swapArrayElements = (arr, indexA, indexB) => {
    const temp = arr[indexA];
    arr[indexA] = arr[indexB];
    arr[indexB] = temp;
    return arr;
  };

  const mobileRoutes = swapArrayElements(routes, routes.length - 2, routes.length - 1);

  const FULL_SCREENS_PATHS = useMemo(
    () => [
      '/dashboard/card/cryptodraft',
      '/dashboard/settings/upgrade-account',
      '/dashboard/card/order-card',
      '/dashboard/staking/features',
      '/dashboard/card/payment-banner-info',
      '/dashboard/card/loyalty',
      '/dashboard/card/settings',
    ],
    []
  );

  const fullScreenRoutes = useMemo(
    () => FULL_SCREENS_PATHS.includes(pathname),
    [pathname, FULL_SCREENS_PATHS]
  );

  const [featureShowStatusBar] = useSetting('app_features', 'feature_show_status_bar');
  const [statusBannerTitle] = useSetting('status_banner', 'status_banner_title');
  const [statusBannerMainText] = useSetting('status_banner', 'status_banner_main_text');
  const [statusBannerAdditional] = useSetting('status_banner', 'status_banner_additional_text');
  const [statusBannerIsOptional] = useSetting('status_banner', 'status_banner_is_optional');

  return (
    <div>
      {featureShowStatusBar && state.isShowingStatusBanner && (
        <div className="d-none d-md-block">
          <StatusBanner
            statusBannerTitle={statusBannerTitle}
            statusBannerMainText={statusBannerMainText}
            statusBannerIsOptional={statusBannerIsOptional}
            setShowingStatusBanner={changeShowingStatusBanner}
            statusBannerAdditional={statusBannerAdditional}
          />
        </div>
      )}
      <div
        className={`mobile-screen-layout ${fullScreenRoutes ? 'full-screen-layout' : ''} ${
          !fullScreenRoutes
            ? 'container-md px-xl-5 px-md-3 pt-md-5 p-0 mb-sm-0 mb-4 contained-screen-layout'
            : ''
        }
         `}
        style={{
          paddingBottom: fullScreenRoutes ? '5rem' : '',
        }}>
        {featureShowStatusBar && state.isShowingStatusBanner && (
          <div className="d-block d-md-none">
            <StatusBanner
              statusBannerTitle={statusBannerTitle}
              statusBannerMainText={statusBannerMainText}
              statusBannerIsOptional={statusBannerIsOptional}
              setShowingStatusBanner={changeShowingStatusBanner}
              statusBannerAdditional={statusBannerAdditional}
            />
          </div>
        )}

        {!fullScreenRoutes && (
          <nav className="d-none d-md-block navbar navbar-expand" style={{ zIndex: 9 }}>
            <div className="collapse navbar-collapse">
              <ul className="navbar-nav w-100">
                {routes
                  .filter((c) => !c.isRight && c.isDisabled === false)
                  .map(({ path, title, isLoading, className }) => (
                    <li
                      key={`${path}-${title}`}
                      className={`nav-item ${className} ${
                        pathname.indexOf(path) === 0 ? 'active' : ''
                      } cursor-pointer ${isLoading ? 'px-5 pb-2' : 'px-2 py-0'}`}>
                      {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center w-100 h-100">
                          <DashboardTabSkeleton />
                        </div>
                      ) : (
                        <Link className="nav-link px-4" to={path}>
                          <b>{title}</b>
                        </Link>
                      )}
                    </li>
                  ))}
                {routes
                  .filter((c) => c.isRight && !c.isDisabled && c.icon)
                  .map(
                    ({
                      title,
                      path,
                      icon,
                      tooltipLabel,
                      tooltipTop,
                      tooltipLeft,
                      className,
                      isExternal,
                    }) => (
                      <li
                        key={`${path}-${title}`}
                        onMouseEnter={() =>
                          setHoverIconsStatus({ [icon]: !hoverIconsStatus[icon] })
                        }
                        onMouseLeave={() =>
                          setHoverIconsStatus({ [icon]: !hoverIconsStatus[icon] })
                        }
                        className={`${className} d-flex tooltip-parent align-items-center cursor-pointer position-relative`}>
                        {isExternal && (
                          // eslint-disable-next-line jsx-a11y/control-has-associated-label
                          <a
                            className="nav-link py-0"
                            style={{ maxWidth: '2.5rem' }}
                            href={path}
                            target="_blank"
                            rel="noreferrer">
                            <Icon
                              icon={icon}
                              color={
                                pathname.indexOf(path) === 0 || hoverIconsStatus[icon]
                                  ? MAIN_ICON_COLORS.PRIMARY
                                  : MAIN_ICON_COLORS.WHITE
                              }
                            />
                          </a>
                        )}
                        {!isExternal && (
                          <Link className="nav-link py-0" style={{ maxWidth: '2.5rem' }} to={path}>
                            <Icon
                              icon={icon}
                              color={
                                pathname.indexOf(path) === 0 || hoverIconsStatus[icon]
                                  ? MAIN_ICON_COLORS.PRIMARY
                                  : MAIN_ICON_COLORS.WHITE
                              }
                            />
                          </Link>
                        )}
                        {tooltipLabel && (
                          <SimpleTooltip
                            label={tooltipLabel}
                            className="px-3 py-2 rounded-normal text-grey-light"
                            style={{ top: tooltipTop, left: tooltipLeft }}
                          />
                        )}
                      </li>
                    )
                  )}
              </ul>
            </div>
          </nav>
        )}
        <ModalLayout
          contentClassName="px-0"
          renderCustomModalHeader={() => (
            <div className="d-flex flex-row justify-content-between align-items-center border-bottom border-shadow border-bottom-1 ps-3 pb-3">
              <b className="text-f5 me-auto">{translate('services_tab_label')}</b>

              <i
                onClick={() => setIsModalVisible(false)}
                onKeyDown={() => setIsModalVisible(false)}
                role="button"
                className="close-btn bg-shadow rounded-max p-2 text-f6 position-relative me-3 cursor-pointer icon icon-close-other text-light"
                tabIndex={-1}
                aria-label="Close"
              />
            </div>
          )}
          onHide={() => setIsModalVisible(false)}
          isVisible={isModalVisible}
          currentScreen={currentScreen}>
          <Services hide={() => setIsModalVisible(false)} keyName={MODAL_SCREENS.SERVICES} />
        </ModalLayout>
        <Switch>{children}</Switch>
      </div>
      {!fullScreenRoutes && (
        <div
          className="d-flex d-md-none flex-row-center bg-lighter hide-scroll fixed-bottom border-top border-disabled"
          style={{ zIndex: 100 }}>
          {(mobileRoutes || [])
            .filter((c) => !c.isDisabled)
            .map(({ path, title, icon, activeIcon, isLink, modal, services, image, className }) => (
              <div
                key={`${path}-${title}`}
                className={`px-4 py-3 mx-auto ${className}`}
                style={{
                  flex: '1 1 0',
                }}>
                {isLink && (
                  <Link className="text-f6 d-md-none" style={{ textDecoration: 'none' }} to={path}>
                    <span className="d-flex flex-column align-items-center">
                      {icon && (
                        <i
                          className={`icon ${
                            pathname.indexOf(path) === 0 ? activeIcon : icon
                          } d-flex justify-content-center align-items-center ${
                            pathname.indexOf(path) === 0 ? 'text-primary' : 'text-shadow'
                          }`}
                          style={{ fontSize: '1.5rem' }}
                        />
                      )}
                      {image && (
                        <div style={{ height: '1.5rem', width: '1.5rem' }}>
                          <Icon
                            icon={ICONS.USER_SETTINGS}
                            color={
                              pathname.indexOf(path) === 0
                                ? MAIN_ICON_COLORS.PRIMARY
                                : MAIN_ICON_COLORS.SHADOW
                            }
                          />
                        </div>
                      )}
                      <b
                        style={{ fontWeight: 'normal' }}
                        className={`text-center ${
                          pathname.indexOf(path) === 0 ? 'text-white' : 'text-shadow'
                        }`}>
                        {title}
                      </b>
                    </span>
                  </Link>
                )}
                {!isLink && (
                  <div
                    role="button"
                    tabIndex="0"
                    onClick={() => showScreen(modal)}
                    onKeyDown={() => showScreen(modal)}
                    className="text-f6">
                    <span className="d-flex flex-column align-items-center">
                      {icon && services && services.length > 0 && (
                        <i
                          className={`icon ${
                            pathname.indexOf(path) === 0 ? activeIcon : icon
                          } d-flex justify-content-center align-items-center ${
                            pathname.indexOf(services[0]) === 11 ||
                            pathname.indexOf(services[1]) === 11 ||
                            pathname.indexOf(services[2]) === 11 ||
                            pathname.indexOf(services[3]) === 11
                              ? 'text-primary'
                              : 'text-shadow'
                          }`}
                          style={{ fontSize: '1.5rem' }}
                        />
                      )}

                      {services && services.length > 0 && (
                        <b
                          style={{ fontWeight: 'normal' }}
                          className={`${
                            pathname.indexOf(services[0]) === 11 ||
                            pathname.indexOf(services[1]) === 11 ||
                            pathname.indexOf(services[2]) === 11 ||
                            pathname.indexOf(services[3]) === 11
                              ? 'text-white'
                              : 'text-shadow'
                          }`}>
                          {title}
                        </b>
                      )}
                    </span>
                  </div>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
